import React from 'react'
import styled from 'styled-components'

const SwapInputSymbol = styled.div`
  color: ${({ theme }) => theme.tradeCurrencyTextColor};
  background-color: inherited;
  pointer-events: auto;
  src: $(props => props.src);
  font-size: 1.75rem;
  //    margin-left: 0.15em;
  text-align: left;
  align-self: center;
  justify-content: left;
`

export default SwapInputSymbol
